import isFinite from 'lodash/isFinite';
import isNil from 'lodash/isNil';

import sy from '~/styles';
import {Text} from '~/components/controls';
import Format from '~/lib/format';

import PublishedWithChangesIcon from '~/images/md-icons/published_with_changes/materialicons/24px.svg';
import MoreTimeIcon from '~/images/md-icons/more_time/materialicons/24px.svg';
import TimerIcon from '~/images/md-icons/timer/materialsymbolsoutlined/24px.svg';
import PropTypes from 'prop-types';

export const DurationText = ({
  duration,
  original_duration,
  original_work_time,
  calculated_work_time,
}) => {
  if (!isFinite(duration)) {
    return null;
  }

  let work_time;
  if (
    isNil(original_duration) &&
    isFinite(calculated_work_time) &&
    duration === calculated_work_time
  ) {
    work_time = original_work_time;
  } else {
    work_time = isFinite(calculated_work_time)
      ? calculated_work_time
      : original_work_time;
  }

  return (
    <>
      {isFinite(work_time) && duration !== work_time && (
        <Text
          style={[
            sy.smallCondensedRegular,
            sy['text-lightgray'],
            sy['line-through'],
          ]}>
          {Format.number(work_time, 2)}
          &nbsp;u
        </Text>
      )}
      <Text
        style={[sy.smallCondensedRegular, sy['text-lightgray'], sy.underline]}>
        {Format.number(duration, 2)}
        &nbsp;u
      </Text>
    </>
  );
};
DurationText.propTypes = {
  duration: PropTypes.any,
  original_duration: PropTypes.any,
  original_work_time: PropTypes.any,
  calculated_work_time: PropTypes.any,
};

export const DurationIcon = ({
  width = 18,
  height = 18,
  duration,
  original_duration,
  original_work_time,
  calculated_work_time,
}) => {
  if (!isFinite(duration)) {
    return null;
  }

  if (
    isNil(original_duration) &&
    isFinite(calculated_work_time) &&
    duration === calculated_work_time
  ) {
    return (
      <PublishedWithChangesIcon fill="#299976" width={width} height={height} />
    );
  }

  if (!isFinite(original_work_time)) {
    return <TimerIcon fill="#FF6C00" width={width} height={height} />;
  }

  const work_time = isFinite(calculated_work_time)
    ? calculated_work_time
    : original_work_time;

  if (duration > work_time) {
    return <MoreTimeIcon fill="#FF6C00" width={width} height={height} />;
  }
};
DurationIcon.propTypes = {
  width: PropTypes.any,
  height: PropTypes.any,
  duration: PropTypes.any,
  original_duration: PropTypes.any,
  original_work_time: PropTypes.any,
  calculated_work_time: PropTypes.any,
};
